import { enCommon } from '../en';
import { frCommon } from '../fr';
import { esCommon } from '../es';
import { deCommon } from '../de';

export const commonModuleTranslations = {
  en: enCommon,
  fr: frCommon,
  es: esCommon,
  de: deCommon,
} as const;
